// // src/pages/FriendListPage.jsx
// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useAuth } from '../contexts/authContext';
// import { API_URL } from '../lib/config';
// import { useSocket } from '../contexts/socketContext';
// import CommonButton from '../components/CommonButton';
// import './FriendListPage.css';

// function FriendListPage() {
//     const { currentUser } = useAuth();
//     const navigate = useNavigate();
//     const socket = useSocket();
    
//     const [myFriends, setMyFriends] = useState([]);
//     const [loading, setLoading] = useState(true);

//     const [selectedFriend, setSelectedFriend] = useState(null); // 클릭한 친구 객체
//     const [editNickname, setEditNickname] = useState('');     // 수정할 별명 입력값

//     // ▼▼▼ [추가] 소켓 이벤트 리스너 (요청 결과 알림용)
//     useEffect(() => {
//         if (!socket) return;

//         const handleRequestSent = ({ message }) => {
//             alert(message); // "친구에게 쪽지를 보냈습니다!"
//             setSelectedFriend(null); // 전송 후 모달 닫기 (선택사항)
//         };

//         const handleErrorFeedback = ({ message }) => {
//             alert(message);
//         };

//         // 이벤트 이름은 백엔드와 맞춰주세요 (friend_chat_request_sent)
//         socket.on('friend_chat_request_sent', handleRequestSent);
//         socket.on('error_feedback', handleErrorFeedback);

//         return () => {
//             socket.off('friend_chat_request_sent', handleRequestSent);
//             socket.off('error_feedback', handleErrorFeedback);
//         };
//     }, [socket]);

//     // 친구 목록 불러오기
//     useEffect(() => {
//         const fetchFriends = async () => {
//             if (!currentUser) return;
//             setLoading(true);
//             try {
//                 const idToken = await currentUser.getIdToken();
//                 const res = await fetch(`${API_URL}/api/friends`, {
//                     headers: { 'Authorization': `Bearer ${idToken}` }
//                 });
//                 const data = await res.json();
                
//                 if (res.ok) {
//                     setMyFriends(data.friends || []);
//                 }
//             } catch (error) {
//                 console.error("친구 목록 로드 실패:", error);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchFriends();
//     }, [currentUser]);

//     // 친구 삭제
//     const handleDeleteFriend = async (friendId, nickname) => {
//         if (!window.confirm(`'${nickname}'님을 친구 목록에서 삭제하시겠습니까?`)) return;

//         try {
//             const idToken = await currentUser.getIdToken();
//             const res = await fetch(`${API_URL}/api/friends/${friendId}`, {
//                 method: 'DELETE',
//                 headers: { 'Authorization': `Bearer ${idToken}` }
//             });

//             if (res.ok) {
//                 setMyFriends(prev => prev.filter(f => f.friendId !== friendId));
//             } else {
//                 alert("삭제 실패");
//             }
//         } catch (e) {
//             console.error(e);
//         }
//     };

//     const handleFriendClick = (friend) => {
//         setSelectedFriend(friend);
//         setEditNickname(friend.customNickname); // 현재 설정된 별명으로 초기화
//     };

//     const handleUpdateNickname = async () => {
//         if (!selectedFriend || !editNickname.trim()) return alert("별명을 입력해주세요.");

//         try {
//             const idToken = await currentUser.getIdToken();
//             const res = await fetch(`${API_URL}/api/friends/${selectedFriend.friendId}`, {
//                 method: 'PATCH',
//                 headers: { 
//                     'Content-Type': 'application/json',
//                     'Authorization': `Bearer ${idToken}`
//                 },
//                 body: JSON.stringify({ newNickname: editNickname })
//             });

//             if (res.ok) {
//                 alert("이름이 변경되었습니다.");
//                 // 목록 즉시 업데이트 (새로고침 없이 반영)
//                 setMyFriends(prev => prev.map(f => 
//                     f.friendId === selectedFriend.friendId 
//                         ? { ...f, customNickname: editNickname } 
//                         : f
//                 ));
//                 setSelectedFriend(null); // 모달 닫기
//             } else {
//                 alert("변경 실패");
//             }
//         } catch (error) {
//             console.error(error);
//             alert("오류가 발생했습니다.");
//         }
//     };

//     // ▼▼▼ [추가] 쪽지 보내기 핸들러 (모달 내부 버튼용)
//     const handleSendNote = () => {
//         // selectedFriend가 현재 모달에 띄워진 친구입니다.
//         if (!selectedFriend || !socket || !currentUser) return;

//         // [CASE 1] 이미 채팅방이 있는 경우 (친구 데이터에 chatRoomId가 있다고 가정)
//         if (selectedFriend.chatRoomId) {
//             navigate('/chat', { 
//                 state: { 
//                     chatRoomId: selectedFriend.chatRoomId, 
//                     partner: selectedFriend,
//                     from: '/friends'
//                 } 
//             });
//             return;
//         }

//         // [CASE 2] 채팅방이 없는 경우 -> 첫 쪽지(초대) 보내기
//         const initialMessage = prompt(`'${selectedFriend.customNickname}'님에게 보낼 첫 쪽지를 입력하세요.`);

//         if (initialMessage && initialMessage.trim() !== '') {
//             socket.emit('request_friend_chat', {
//                 senderId: currentUser.uid, 
//                 receiverId: selectedFriend.friendId, // 친구의 ID
//                 initialMessage: initialMessage.trim()
//             });
//         } else if (initialMessage !== null) {
//             alert("내용을 입력해야 쪽지를 보낼 수 있습니다.");
//         }
//     };

//     return (
//         <div className="friend-page-container">
//             <div className="friend-page-header">
//                 {/* 1. 뒤로가기 아이콘 버튼 */}
//                 <button className="back-button-icon" onClick={() => navigate(-1)}>
//                     {'<'}
//                 </button>
                
//                 {/* 2. 페이지 제목 */}
//                 <h1 className="friend-page-title">
//                     내 친구 목록 ({loading ? '...' : myFriends.length})
//                 </h1>
                
//                 {/* 3. 오른쪽 균형을 위한 빈 공간 (선택사항) */}
//                 <div style={{ width: '24px' }}></div>
//             </div>

//             <div className="friend-list-area">
//                 {loading ? (
//                     <div className="loading-text">목록을 불러오는 중...</div>
//                 ) : (
//                     <ul className="friend-ul">
//                         {myFriends.length === 0 ? (
//                             <p className="empty-msg">아직 등록된 친구가 없습니다.</p>
//                         ) : (
//                             myFriends.map(friend => (
//                                 <li key={friend.friendId} className="friend-li clickable" onClick={() => handleFriendClick(friend)}>
//                                     <div className="friend-info">
//                                         <div className="friend-names">
//                                             {/* 내가 설정한 닉네임 크게 */}
//                                             <span className="custom-nick">{friend.customNickname}</span>
                                            
//                                             {/* 원래 닉네임이 다르면 괄호로 표시 */}
//                                             {friend.customNickname !== friend.originalNickname && (
//                                                 <span className="orig-nick">({friend.originalNickname})</span>
//                                             )}
//                                         </div>
//                                         <span className="friend-char">{friend.character}</span>
//                                     </div>
                                    
//                                     <div className="friend-actions">
//                                         <button 
//                                             className="del-btn"
//                                             onClick={(e) => {
//                                                 e.stopPropagation(); // 핵심: 부모(li)에게 클릭 이벤트를 전달하지 않음
//                                                 handleDeleteFriend(friend.friendId, friend.customNickname);
//                                             }}
//                                         >
//                                             삭제
//                                         </button>
//                                     </div>
//                                 </li>
//                             ))
//                         )}
//                     </ul>
//                 )}
//             </div>

//             {/* ▼▼▼ [추가] 친구 상세 정보 및 수정 모달 ▼▼▼ */}
//             {selectedFriend && (
//                 <div className="modal-overlay" onClick={() => setSelectedFriend(null)}>
//                     <div className="friend-detail-card" onClick={(e) => e.stopPropagation()}>
                        
//                         {/* 1. 프로필 정보 표시 */}
//                         <h2 className="detail-orig-nick">{selectedFriend.originalNickname}</h2>
//                         <div className="detail-char-box">
//                             <p>{selectedFriend.character}</p>
//                         </div>

//                         <div style={{ width: '100%', marginBottom: '20px' }}>
//                             <CommonButton 
//                                 text={selectedFriend.chatRoomId ? "대화 이어하기" : "쪽지 보내기"} 
//                                 variant="primary" 
//                                 onClick={handleSendNote}
//                                 style={{ width: '100%', backgroundColor: '#6c5ce7' }} // 보라색 포인트
//                             />
//                         </div>

//                         {/* 2. 별명 수정 영역 */}
//                         <div className="detail-edit-area">
//                             <label>저장된 이름</label>
//                             <input 
//                                 type="text" 
//                                 className="detail-input"
//                                 value={editNickname} 
//                                 onChange={(e) => setEditNickname(e.target.value)}
//                                 placeholder="이름을 입력하세요"
//                             />
//                         </div>

//                         {/* 3. 버튼 영역 */}
//                         <div className="detail-buttons">
//                             <CommonButton 
//                                 text="저장" 
//                                 variant="primary" 
//                                 onClick={handleUpdateNickname}
//                                 style={{ flex: 1 }}
//                             />
//                             <CommonButton 
//                                 text="닫기" 
//                                 variant="secondary" 
//                                 onClick={() => setSelectedFriend(null)}
//                                 style={{ flex: 1 }}
//                             />
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// }

// export default FriendListPage;

// src/pages/FriendListPage.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/authContext';
import { API_URL } from '../lib/config';
import { useSocket } from '../contexts/socketContext';
import CommonButton from '../components/CommonButton';
import './FriendListPage.css';

function FriendListPage() {
    const { currentUser } = useAuth();
    const navigate = useNavigate();
    const socket = useSocket();
    
    const [myFriends, setMyFriends] = useState([]);
    const [loading, setLoading] = useState(true);

    const [selectedFriend, setSelectedFriend] = useState(null); 
    const [editNickname, setEditNickname] = useState('');     
    const [isEditing, setIsEditing] = useState(false);

    // 소켓 리스너
    useEffect(() => {
        if (!socket) return;
        const handleRequestSent = ({ message }) => {
            alert(message); 
            setSelectedFriend(null); 
        };
        const handleErrorFeedback = ({ message }) => {
            alert(message);
        };
        socket.on('friend_chat_request_sent', handleRequestSent);
        socket.on('error_feedback', handleErrorFeedback);
        return () => {
            socket.off('friend_chat_request_sent', handleRequestSent);
            socket.off('error_feedback', handleErrorFeedback);
        };
    }, [socket]);

    // 친구 목록 로드
    useEffect(() => {
        const fetchFriends = async () => {
            if (!currentUser) return;
            setLoading(true);
            try {
                const idToken = await currentUser.getIdToken();
                const res = await fetch(`${API_URL}/api/friends`, {
                    headers: { 'Authorization': `Bearer ${idToken}` }
                });
                const data = await res.json();
                if (res.ok) setMyFriends(data.friends || []);
            } catch (error) {
                console.error("친구 목록 로드 실패:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchFriends();
    }, [currentUser]);

    // 친구 삭제
    const handleDeleteFriend = async (friendId, nickname) => {
        if (!window.confirm(`'${nickname}'님을 친구 목록에서 삭제하시겠습니까?`)) return;
        try {
            const idToken = await currentUser.getIdToken();
            const res = await fetch(`${API_URL}/api/friends/${friendId}`, {
                method: 'DELETE',
                headers: { 'Authorization': `Bearer ${idToken}` }
            });
            if (res.ok) {
                setMyFriends(prev => prev.filter(f => f.friendId !== friendId));
            } else {
                alert("삭제 실패");
            }
        } catch (e) {
            console.error(e);
        }
    };

    // 모달 열기
    const handleFriendClick = (friend) => {
        setSelectedFriend(friend);
        setEditNickname(friend.customNickname);
        setIsEditing(false); 
    };

    // 닉네임 수정
    const handleUpdateNickname = async () => {
        if (!selectedFriend || !editNickname.trim()) return alert("별명을 입력해주세요.");

        try {
            const idToken = await currentUser.getIdToken();
            const res = await fetch(`${API_URL}/api/friends/${selectedFriend.friendId}`, {
                method: 'PATCH',
                headers: { 
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${idToken}`
                },
                body: JSON.stringify({ newNickname: editNickname })
            });

            if (res.ok) {
                setMyFriends(prev => prev.map(f => 
                    f.friendId === selectedFriend.friendId 
                        ? { ...f, customNickname: editNickname } 
                        : f
                ));
                setSelectedFriend(prev => ({ ...prev, customNickname: editNickname }));
                setIsEditing(false); 
            } else {
                alert("변경 실패");
            }
        } catch (error) {
            console.error(error);
            alert("오류가 발생했습니다.");
        }
    };

    // 쪽지 보내기
    const handleSendNote = () => {
        if (!socket || !currentUser) return alert('서버에 연결되지 않았습니다.');
        if (!selectedFriend) return;

        // 1. 이미 채팅방이 있으면 바로 이동
        if (selectedFriend.chatRoomId) {
            navigate('/chat', { 
                state: { 
                    chatRoomId: selectedFriend.chatRoomId, 
                    partner: selectedFriend,
                    from: '/friends'
                } 
            });
            return;
        }

        // 2. 채팅방이 없으면 프롬프트 띄우기 (AIMatchingPage와 동일)
        const initialMessage = prompt(`'${selectedFriend.customNickname}'님에게 보낼 메시지를 입력하세요.`);

        if (initialMessage && initialMessage.trim() !== '') {
            const currentUserId = localStorage.getItem('currentUserId');
            if (!currentUserId) {
                return alert("로그인 정보를 찾을 수 없습니다. 다시 로그인해주세요.");
            }
            // 3. 백엔드에 요청 Emit
            // 주의: 백엔드가 'request_friend_chat' 이벤트를 받고 있는지 꼭 확인하세요!
            socket.emit('request_friend_chat', {
                senderId: currentUserId,       // 또는 localStorage.getItem('currentUserId')
                receiverId: selectedFriend.friendId, // ★ 여기 변수명이 중요합니다 (friendId)
                initialMessage: initialMessage.trim()
            });

        } else if (initialMessage !== null) {
            // 취소(null)가 아니고 빈 문자열일 때만 경고
            alert('메시지를 입력해야 대화를 시작할 수 있습니다.');
        }
    };

    return (
        <div className="friend-page-container">
            <div className="friend-page-header">
                <button className="back-button-icon" onClick={() => navigate(-1)} aria-label="뒤로 가기">
                   <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15 19L8 12L15 5" stroke="#333333" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </button>
                <h1 className="friend-page-title">
                    내 친구 목록 ({loading ? '...' : myFriends.length})
                </h1>
                <div style={{ width: '24px' }}></div>
            </div>

            <div className="friend-list-area">
                {loading ? (
                    <div className="loading-text">목록을 불러오는 중...</div>
                ) : (
                    <ul className="friend-ul">
                        {myFriends.length === 0 ? (
                            <p className="empty-msg">아직 등록된 친구가 없습니다.</p>
                        ) : (
                            myFriends.map(friend => (
                                <li key={friend.friendId} className="friend-li clickable" onClick={() => handleFriendClick(friend)}>
                                    <div className="friend-info">
                                        <div className="friend-names">
                                            <span className="custom-nick">{friend.customNickname}</span>
                                            {friend.customNickname !== friend.originalNickname && (
                                                <span className="orig-nick">({friend.originalNickname})</span>
                                            )}
                                        </div>
                                        <span className="friend-char">{friend.character}</span>
                                    </div>
                                    <div className="friend-actions">
                                        <button 
                                            className="del-btn"
                                            onClick={(e) => {
                                                e.stopPropagation(); 
                                                handleDeleteFriend(friend.friendId, friend.customNickname);
                                            }}
                                        >
                                            삭제
                                        </button>
                                    </div>
                                </li>
                            ))
                        )}
                    </ul>
                )}
            </div>

            {/* ▼▼▼ 모달 영역 ▼▼▼ */}
            {selectedFriend && (
                <div className="modal-overlay" onClick={() => setSelectedFriend(null)}>
                    <div 
                        className="friend-detail-card" 
                        onClick={(e) => e.stopPropagation()} 
                        style={{ 
                            position: 'relative', 
                            padding: '30px 25px', 
                            backgroundColor: '#222', 
                            color: '#fff', 
                            border: '1px solid #444',
                            boxShadow: '0 10px 30px rgba(0,0,0,0.5)'
                        }}
                    >
                        
                        {/* 닫기 버튼 */}
                        <button 
                            onClick={() => setSelectedFriend(null)}
                            style={{
                                position: 'absolute', top: '15px', right: '15px',
                                background: 'none', border: 'none', cursor: 'pointer', padding: '5px'
                            }}
                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#888" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                        </button>

                        {/* 1. 상단: 저장된 이름 & 수정 영역 */}
                        <div className="modal-header-section" style={{ marginBottom: '25px', borderBottom: '1px solid #333', paddingBottom: '15px' }}>
                            <label style={{ fontSize: '12px', color: '#888', marginBottom: '8px', display: 'block', textAlign: 'left' }}>
                                저장된 이름
                            </label>
                            
                            {isEditing ? (
                                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                    <input 
                                        type="text" 
                                        value={editNickname}
                                        onChange={(e) => setEditNickname(e.target.value)}
                                        className="detail-input"
                                        style={{ 
                                            margin: 0, flex: 1, height: '40px', 
                                            backgroundColor: '#333', color: '#fff', border: '1px solid #555' 
                                        }}
                                        autoFocus
                                    />
                                    <button onClick={handleUpdateNickname} style={{ backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '6px', width: '40px', height: '40px', cursor: 'pointer' }}>
                                        V
                                    </button>
                                    <button onClick={() => { setIsEditing(false); setEditNickname(selectedFriend.customNickname); }} style={{ backgroundColor: '#444', color: '#ccc', border: 'none', borderRadius: '6px', width: '40px', height: '40px', cursor: 'pointer' }}>
                                        X
                                    </button>
                                </div>
                            ) : (
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <h2 style={{ margin: 0, fontSize: '1.8rem', color: '#ffffff', fontWeight: 'bold' }}>
                                        {selectedFriend.customNickname}
                                    </h2>
                                    <button 
                                        onClick={() => setIsEditing(true)}
                                        style={{ 
                                            background: 'none', border: 'none', cursor: 'pointer', padding: '5px', 
                                            display: 'flex', alignItems: 'center', opacity: 0.7 
                                        }}
                                        title="이름 수정"
                                    >
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                                            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                                        </svg>
                                    </button>
                                </div>
                            )}
                        </div>

                        {/* 2. 중간: 정보 영역 (수정된 부분: 줄바꿈 적용) */}
                        <div className="modal-info-section" style={{ marginBottom: '35px', textAlign: 'left' }}>
                            
                            {/* ▼▼▼ 여기를 '저장된 이름' 스타일처럼 라벨을 block으로 만들었습니다 ▼▼▼ */}
                            <div style={{ marginBottom: '15px' }}>
                                <label style={{ fontSize: '12px', color: '#888', marginBottom: '5px', display: 'block' }}>
                                    현재 대표 프로필
                                </label>
                                <div style={{ fontSize: '1.1rem', color: '#fff', fontWeight: '600' }}>
                                    {selectedFriend.originalNickname}
                                </div>
                            </div>
                            
                            {/* 특성 박스 */}
                            <div className="detail-char-box" style={{ 
                                backgroundColor: 'rgba(255, 255, 255, 0.08)',
                                border: '1px solid rgba(255, 255, 255, 0.1)',
                                padding: '15px', 
                                borderRadius: '10px', 
                                color: '#ccc', 
                                fontSize: '14px', 
                                lineHeight: '1.6' 
                            }}>
                                {selectedFriend.character}
                            </div>
                        </div>

                        {/* 3. 하단: 쪽지 보내기 버튼 */}
                        <div className="modal-action-section">
                            <CommonButton 
                                text={selectedFriend.chatRoomId ? "대화 이어하기" : "쪽지 보내기"} 
                                variant="primary" 
                                onClick={handleSendNote}
                                style={{ 
                                    width: '100%', 
                                    backgroundColor: '#00a8ff', 
                                    padding: '16px', 
                                    fontSize: '1.1rem',
                                    fontWeight: 'bold',
                                    boxShadow: '0 4px 15px rgba(0, 168, 255, 0.4)',
                                    borderRadius: '12px'
                                }} 
                            />
                        </div>

                    </div>
                </div>
            )}
        </div>
    );
}

export default FriendListPage;